import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './SignInSecurity.style';

import * as PageStyled from '../../AccountSettings.style';
import { TwoStepVerification } from '../TwoStepVerification';

export const LOCALIZED_TEXT = {
  title: 'dashboard.accountSettings.password.title',
  description: 'dashboard.accountSettings.password.description',
  changePassword: 'dashboard.accountSettings.password.changePassword',
};

const SignInSecurity = ({ isSocialLogin, onClickManagePassword }) => {
  const { formatMessage: fm } = useIntl();

  return (
    <Stack gap={{ xs: 3, sm: 4 }}>
      {!isSocialLogin && (
        <PageStyled.AccountCard>
          <Styled.PasswordRow>
            <div>
              <Heading component="h2" size="lg">
                {fm({ id: LOCALIZED_TEXT.title })}
              </Heading>
              <Text component="p" size="md" color="secondary">
                {fm({ id: LOCALIZED_TEXT.description })}
              </Text>
            </div>
            <PageStyled.ButtonLink onClick={onClickManagePassword} size="md" variant="text" color="info">
              {fm({ id: LOCALIZED_TEXT.changePassword })}
            </PageStyled.ButtonLink>
          </Styled.PasswordRow>
        </PageStyled.AccountCard>
      )}
      <TwoStepVerification />
    </Stack>
  );
};

SignInSecurity.propTypes = {
  isSocialLogin: PropTypes.bool.isRequired,
  onClickManagePassword: PropTypes.func.isRequired,
};

export default SignInSecurity;
